module.exports = __webpack_public_path__ + "img/tips-recommend.62221a63.png";